import {Fancybox} from '@fancyapps/ui';

export default function initializeFancybox() {
    Fancybox.bind("[data-fancybox]", {
        on: {
            reveal: (fancybox, slide) => {
                // console.log(`#${slide.index} slide is loaded!`);
                // console.log(
                //     `This slide is selected: ${fancybox.getSlide().index === slide.index}`
                // );
                if(window.devicePixelRatio > 1 && window.innerWidth > 1200) {
                    document.body.style.removeProperty('width');
                    document.body.style.removeProperty('height');
                    document.body.style.removeProperty('webkitTransform');   // Chrome, Opera, Safari
                    document.body.style.removeProperty('msTransform');       // IE 9
                    document.body.style.removeProperty('transform');   // General
                    document.body.style.removeProperty('transformOrigin');    // General
                    document.getElementsByTagName("html")[0].style.removeProperty('height');
                }
            },
            closing: (fancybox, slide) => {
                if(window.devicePixelRatio > 1 && window.innerWidth > 1200) {
                    var scale = 'scale(' + 1 / window.devicePixelRatio + ')';
                    document.body.style.width = window.devicePixelRatio * 100 +
                        '%';
                    document.body.style.height = window.devicePixelRatio * 100 +
                        '%';
                    document.body.style.webkitTransform = scale;    // Chrome, Opera, Safari
                    document.body.style.msTransform = scale;       // IE 9
                    document.body.style.transform = scale;     // General
                    document.body.style.transformOrigin = 'top left';     // General
                    document.getElementsByTagName(
                        "html" )[0].style.height = '100%';
                }
            }
        },
    });
}